// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__dmTN1","panel":"styles_panel__0482G"};